<template>
  <div>
    <v-form v-model="valid" ref="form">

      <EmailField v-model="email">
      </EmailField>
      <v-text-field v-model="password" ref="passwordfield" :label="$t('text.password')" min="8"
        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append-inner="showPassword = !showPassword"
        :type="showPassword ? 'text' : 'password'" id="pw" autocomplete="current-password" :rules="passwordRules"
        counter variant="outlined" density="compact" validate-on="blur" required @keydown.enter.prevent="submit">
      </v-text-field>

      <WideBtn :text="$t('customer.portal.loginbutton')" color="var(--v-tertiary-base)" :disabled="!valid"
        :loading="loginInProgress" @click="submit()">
      </WideBtn>
      <WideBtn :text="$t('customer.portal.forgot_password')" color="var(--v-tertiary-base)" :disabled="loginInProgress"
        :filled="false" @click="mode = 'send'">
      </WideBtn>

      <v-snackbar v-model="snackbar" color="error">{{ snackbarText }}</v-snackbar>
    </v-form>
  </div>
</template>


<script>
import EmailField from '@/components/Inputs/EmailField.vue';
import WideBtn from '@/components/WideBtn.vue';

export default {
  name: "LoginContent",
  props: {
    loginFunction: {
      type: Function,
      required: true,
    }
  },
  components: {
    WideBtn,
    EmailField,
  },

  data() {
    return {
      snackbar: false,
      snackbarText: "",
      loginInProgress: false,
      valid: false,
      showPassword: false,
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
    };
  },

  mounted() { },

  methods: {
    async submit() {
      const validation = await this.$refs.form.validate();
      if (validation.valid) {
        this.loginInProgress = true;
        this.loginFunction({ username: this.email, password: this.password })
          .then((result) => {
            if (!result.success) {
              this.snackbarText = result.errorMessage;
              this.snackbar = true;
            }
            this.loginInProgress = false;
          });
      }
    },
  },

  computed: {
    email: {
      get() {
        return this.getQueryParam("email", "");
      },
      set(update) {
        this.setQueryParam("email", update);
      },
    },

    mode: {
      get() {
        return this.getQueryParam("mode", "");
      },
      set(update) {
        this.setQueryParam("mode", update);
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>